import clsx from 'clsx'
import React from 'react'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { Image } from '@/components/atoms/Image/Image'
import { ReactComponent as Arrow } from '@/assets/icons/thin-arrow-purple.svg'
import { SectionCaseStudiesGridItem } from '@/components/organisms/SectionCaseStudiesGrid/types'

export function Item({ item }: { item: SectionCaseStudiesGridItem }) {
  const { content } = item
  return (
    <CustomLink
      link_url={{
        cached_url: item.full_slug,
        url: '',
        id: item.id,
        linktype: '',
        fieldtype: ''
      }}
      is_external={false}
      key={item.id}
      className="group"
      new_tab={false}
    >
      <div
        key={item.id}
        className="p-16 netbook:p-32 flex flex-col gap-16 netbook:gap-32 border-1 border-primary-300 rounded w-full desktop:w-402 h-full   transition cursor-pointer"
      >
        {content.card_logo && (
          <Image
            fixed
            data={content.card_logo}
            imgClassName="h-48 w-fit tablet:mr-0 "
            width={70}
            height={64}
            className={clsx('h-48 w-fit')}
          />
        )}
        <div className="flex flex-col text-text-dark-900 gap-16 h-full flex-2">
          {content.card_title && <p className="text-bodyL font-bold">{content.card_title}</p>}
          {content.card_teaser && <p className="text-bodyM line-clamp-3">{content.card_teaser}</p>}
        </div>
        <p className="text-bodyL font-bold text-text-brand-primary flex gap-4 items-center group-hover:text-primary-400">
          <span>Read the Story</span>
          <Arrow />
        </p>
      </div>
    </CustomLink>
  )
}
